import { graphql } from "../generated";

export const MUTATE_DELETE_ANIMATION = graphql(`
  mutation MutateDeleteAnimation($id: Int!) {
    deleteAnimation(id: $id)
  }
`);
